import { Component, Input, OnInit } from '@angular/core';
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
import { MetricIconService } from 'src/app/services/metrics/metrics-icons.service';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { QuestionOptionsConstantService } from '../../create-custom-question/options-constant.service';

@Component({
  selector: 'app-preview-questionnaire-blocks',
  templateUrl: './preview-questionnaire-blocks.component.pug',
  styleUrls: ['./preview-questionnaire-blocks.component.scss'],
  standalone: false
})
export class PreviewQuestionnaireBlocksComponent implements OnInit {
  @Input() type='';
  @Input() questions: any[]= [];
  @Input() pageType='';
  @Input() is_additional_comments_enabled
  @Input() default_or_custom_note = '';
  @Input() min_referee = '';
  confirmationQuestion:any;
  options_map = QuestionOptionsConstantService.questionTypes;

  constructor(
    private alertList: AlertBannerService,
    private metricIconService: MetricIconService,
    private questionnaireService:QuestionnaireService) { }

  ngOnInit(): void {
    if(this.type=='candidate'){
      this.questionnaireService.getConfirmationQuestion().subscribe(
        res=>{
          this.confirmationQuestion = res.data;
          this.confirmationQuestion.question_type = 'candidate';
          this.questions.push(this.confirmationQuestion);
        },
        err => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true,
            modal: true
          }]);
        }
      )
    }
  }

  getMetricIcon(metric) {
    return this.metricIconService.getMetricIcon(metric);
  }

}
